// extracted by mini-css-extract-plugin
export const wrapper = "styles-module--wrapper--2wFjY";
export const header = "styles-module--header--3NhVJ";
export const headerTitle = "styles-module--headerTitle--18kX5";
export const list = "styles-module--list--3QJwh";
export const listItem = "styles-module--listItem--3h6Us";
export const setDefault = "styles-module--setDefault--HuE6s";
export const listIcon = "styles-module--listIcon--tZYLu";
export const miniHeading = "styles-module--miniHeading--1wLHq";